export default __webpack_public_path__ + "749aa9f8bc80195faa4ddc235e60d0bd.svg";